import Vue from 'vue'
import VueSelect from 'vue-cool-select'

Vue.use(VueSelect, {
  theme: 'bootstrap' // or 'material-design'
})



// WEBPACK FOOTER //
// ./resources/js/plugins/autocomplete.js